<template>
  <div class="version1-right-right inventor-total">
    <div class="middle-title">
      <img src="../../../../static/version1/标题箭头左.png" alt="">
      <span class="text">{{ title3 || '发明人专利统计' }}</span>
      <img src="../../../../static/version1/标题箭头右.png" alt="">
    </div>
    <div class="totalBar-content">
      <template v-if="inventorList.length > 0">
        <div class="totalBar-title">
          <div class="row" :style="{ width: useNewGovTemplate ? '70%' : '30%' }" title="发明人">发明人</div>
          <div class="row textLeft" style="width: 30%" title="专利申请">专利申请</div>
          <div class="row textLeft" style="width: 40%" title="核心专利" v-if="!useNewGovTemplate">
            核心专利
          </div>
        </div>
        <div class="totalBar-list" @mouseenter="stopAutoplayAnimation" @mouseleave="reStartAnimation">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in inventorList" :key="index">
              <div class="contentRow" @click="detailClick(item)">

                <!-- <div class="row firstRow" style="width: 20%" :title="item.org">
                  {{ item.org }}
                </div> -->
                <div class="row" :style="{ width: useNewGovTemplate ? '70%' : '30%' }" :title="item.name">
                  {{ item.name }}
                </div>
                <div class="row textLeft" style="width: 30%" :title="item.count">
                  {{ item.count }}件
                </div>
                <div class="row textLeft" style="width: 40%" :title="item.coreValue" v-if="!useNewGovTemplate">
                  {{ item.coreValue }}件
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </template>
      <img src="../../../../static/nodata3.png" alt="" v-else class="noData" />
    </div>
  </div>
</template>
<script>
import { getInventor, assigneesNormalRange } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { colorConfig } from './config'
import { mapState } from 'vuex'

export default {
  mixins: [BaseMixin],
  created() {
    this.init()
  },
  data() {
    return {
      inventorList: [],
      swiperOptions: {
        init: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false // 触碰后自动轮播也不会停止
        },
        height: 200,
        // spaceBetween: 5, // 在slide之间设置距离（单位px）
        slidesPerView: 5, // 能够同时显示的slides数量
        direction: 'vertical',
        // 修改swiper自己或子元素时，自动初始化swiper
        observer: true,
        // 修改swiper的父元素时，自动初始化swiper
        observeParents: true,
        pauseOnMouseEnter: true,
        loop: false // 首尾循环
      }
    }
  },
  methods: {
    detailClick(item) {
      if (this.useNewGovTemplate) {
        this.jumpIpi(`专利权人(精确)=(${item.name}) and 专利类型=(发明授权 or 实用新型 or 外观设计)`)
      } else {
        this.jumpIpi('发明人(精确)=' + item.name + ' and 专利类型=(发明申请 or 实用新型 or 外观设计)', 'isMerge', 'publicOrder')
      }
    },
    async init() {
      if (this.useNewGovTemplate) {
        const res = await assigneesNormalRange()
        if (res.code === 200) {
          this.inventorList = res.data
        }
      } else {
        const result = await getInventor()
        this.inventorList = result[this.dataMapping]
      }
      this.inventorList.forEach((element) => {
        if (!element.org) {
          return (element.org = '-')
        }
        colorConfig.forEach((item) => {
          if (item.org === element.org) {
            element.color = item.color
          }
        })
      })
      this.$forceUpdate()
      this.$nextTick(() => {
        this.swiper.init()
      })
    },
    stopAutoplayAnimation() {
      this.swiper.autoplay.stop()
    },
    reStartAnimation() {
      this.swiper.autoplay.start()
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    ...mapState('title', ['title3']),
    ...mapState('user', ['useNewGovTemplate']),
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>
